import { mapState, mapActions } from 'pinia'
import { useAuthStore, useUsersStore, useGlobalStore } from 'src/stores/index.js'
import { getFCMToken } from 'src/utils/fcm'

export const inactivityMixin = {
  data: () => ({
    maxDiff: 15 * 60 * 1000
  }),
  mounted () {
    document.onmousemove = this.checkIdleTime
    document.onmousedown = this.checkIdleTime
    document.ontouchstart = this.checkIdleTime
    document.onclick = this.checkIdleTime
    document.onkeypress = this.checkIdleTime
    document.addEventListener('scroll', this.checkIdleTime, true)
    this.checkIdleTime()
  },
  computed: {
    ...mapState(useAuthStore, ['access_token'])
  },
  methods: {
    ...mapActions(useUsersStore, ['unregisterDevice']),
    ...mapActions(useGlobalStore, { globalLogOut : 'logout' }),
    setTime () {
      const now = Date.now()
      this.$q.localStorage.set('last_interaction', now)
    },
    checkIdleTime () {
      if (this.access_token) {
        const now = Date.now()
        const last_timestamp = this.$q.localStorage.has('last_interaction')
          ? this.$q.localStorage.getItem('last_interaction') !== null
            ? this.$q.localStorage.getItem('last_interaction') : Date.now()
          : Date.now()

        if (now - last_timestamp > this.maxDiff) this.logout()
      }
      this.setTime()
    },
    logout () {
      this.$q.localStorage.remove('last_interaction')
      getFCMToken().then(token => {
        if (token) this.unregisterDevice(token)
      }).catch(console.error)
      this.globalLogOut()
      this.$router.replace({ name: 'login', query: { pendingView: this.$route.path } })
    }
  }
}

export default inactivityMixin
